import { Icon, Stack, Text, VStack, Image, Box } from "@chakra-ui/react";
import React from "react";

const WhoWeServeItem = ({ iconName, title, description }: any) => {
  return (
    <Stack>
      <VStack
        // h="140px"
        justify="start"
        maxW="328px"
        w={{ base: "308px", xl: "320px" }}
        flexGrow={1}
      >
        {/* <Icon as={iconName} w="48px" h="48px" /> */}
        <Image src={iconName} alt="icon" h="48px" w="48px" />

        <Text
          fontSize="36px"
          className="light-text"
          lineHeight="100%"
          textAlign="center"
          as="h3"
          minH={"80px"}
        >
          {title}
        </Text>
        <Text
          fontSize="18px"
          className="regular-text"
          lineHeight="100%"
          textAlign="center"
        >
          {description}
        </Text>
      </VStack>
    </Stack>
  );
};

export default WhoWeServeItem;
